export default __webpack_public_path__ + "static/media/journeytray-greentree-nut.20d61e47.svg";